import { OWNERS, STATUSES, STATUS_LABEL, allTasks, statusOf, cycledStatus, canEditTask } from "./util";

export default function WorkplanBoard({ nodes, isAdmin, onStatus }) {
  const tasks = allTasks(nodes);
  return (
    <div className="wp-board" data-testid="wp-board">
      {STATUSES.map((st) => {
        const col = tasks.filter((t) => statusOf(t) === st);
        return (
          <div className="wp-col" key={st} data-testid={`wp-col-${st}`}>
            <h4>
              {STATUS_LABEL[st]} <span className="wp-col-count">{col.length}</span>
            </h4>
            {col.map((t) => {
              const can = canEditTask(t, isAdmin);
              return (
                <div
                  key={t.id}
                  className={`wp-card ${st === "done" ? "done" : ""}`}
                  onClick={() => can && onStatus(t.id, cycledStatus(t))}
                  style={!can ? { cursor: "default" } : {}}
                  title={can ? "Advance status" : "Read only"}
                  data-testid={`wp-card-${t.id}`}
                >
                  <div className="wp-card-t">{t.title}</div>
                  <div className="wp-card-f">
                    {t.owner && <span className={`wp-owner o-${t.owner}`}>{OWNERS[t.owner]}</span>}
                    {t.est && <span className="wp-est">{t.est}</span>}
                  </div>
                </div>
              );
            })}
            {col.length === 0 && <div className="wp-empty">Nothing here</div>}
          </div>
        );
      })}
    </div>
  );
}
